(function () {
  if (window.ApellaSubcollectionContext) return;

  const stateKey = 'apellaSubcollections';
  const storagePrefix = 'apella-subcollections:';
  const marker = '#apella-nav=';
  const lifetime = 5 * 60 * 1000;
  const originals = new WeakMap();
  const cleanLinks = new WeakMap();
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);

  function collectionPath(value) {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/i.test(url.pathname)) return null;
      return url.pathname.replace(/\/$/, '');
    } catch (_) { return null; }
  }

  function validGroup(group, path) {
    if (!group || typeof group.label !== 'string' || !Array.isArray(group.links) || group.links.length < 2 || group.links.length > 13) return null;
    const links = group.links.map(function (link) {
      if (!link || typeof link.label !== 'string' || !link.label.trim() || link.label.length > 300) return null;
      const url = collectionPath(link.url);
      return url ? { url: url, label: link.label } : null;
    });
    if (links.some(link => !link) || new Set(links.map(link => link.url)).size !== links.length || !links.some(link => link.url === path)) return null;
    return { label: group.label.slice(0, 400), links: links };
  }

  function entryContext() {
    const entry = window.history.state && window.history.state[stateKey];
    const path = collectionPath(window.location.href);
    return entry && entry.path === path ? validGroup(entry.group, path) : null;
  }

  function saveEntry(group, url) {
    const state = Object.assign({}, window.history.state, { searchParams: window.location.search.slice(1) });
    if (group) state[stateKey] = { path: collectionPath(window.location.href), group: group };
    else delete state[stateKey];
    window.history.replaceState(state, '', url || window.location.href);
  }

  function readHandoff() {
    if (!window.location.hash.startsWith(marker)) return null;
    const token = window.location.hash.slice(marker.length);
    const url = new URL(window.location.href);
    url.hash = '';
    let group = null;
    try {
      if (/^[a-f0-9-]{36}$/i.test(token)) {
        const key = storagePrefix + token;
        const handoff = JSON.parse(window.localStorage.getItem(key));
        window.localStorage.removeItem(key);
        const path = collectionPath(url.href);
        if (handoff && handoff.to === path && handoff.from === collectionPath(document.referrer) &&
            Date.now() >= handoff.created && Date.now() - handoff.created < lifetime) {
          group = validGroup(handoff.group, path);
        }
      }
    } catch (_) { /* Unavailable storage falls back to this collection's Canvas row. */ }
    saveEntry(group, url.href);
    return group;
  }

  const load = window.performance.getEntriesByType('navigation')[0];
  let currentGroup = null;
  if (!designMode) {
    currentGroup = readHandoff();
    if (!currentGroup && load && (load.type === 'reload' || load.type === 'back_forward')) currentGroup = entryContext();
    if (!currentGroup && window.history.state && window.history.state[stateKey]) saveEntry(null);
  }

  function snapshot(navigation) {
    return {
      label: navigation.getAttribute('aria-label'),
      links: Array.from(navigation.querySelectorAll('.apella-subcollections__pill')).map(function (link) {
        return { url: collectionPath(cleanLinks.get(link) || link.href), label: link.textContent.trim() };
      })
    };
  }

  function render(navigation) {
    const original = originals.get(navigation);
    const path = collectionPath(navigation.dataset.collectionUrl);
    const group = validGroup(currentGroup, path) || original.group;
    navigation.hidden = group === original.group && original.hidden;
    navigation.setAttribute('aria-label', group.label);
    const track = navigation.querySelector('[data-apella-subcollection-track]');
    track.replaceChildren(...group.links.map(function (item) {
      const link = document.createElement('a');
      link.className = 'apella-subcollections__pill';
      link.href = item.url;
      link.textContent = item.label;
      if (item.url === path) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');
      }
      return link;
    }));
    const active = track.querySelector('[aria-current="page"]');
    if (active) track.scrollLeft += active.getBoundingClientRect().left - track.getBoundingClientRect().left - (track.clientWidth - active.offsetWidth) / 2;
    navigation.dispatchEvent(new CustomEvent('apella:subcollections-updated'));
  }

  function handoffURL(clean, group) {
    if (designMode || !group) return clean;
    try {
      // Short-lived, single-use links support new tabs without remembering a site-wide parent.
      const keys = Object.keys(window.localStorage).filter(key => key.startsWith(storagePrefix));
      keys.forEach(function (key, index) {
        let saved;
        try { saved = JSON.parse(window.localStorage.getItem(key)); } catch (_) { /* Remove malformed records. */ }
        if (!saved || Date.now() - saved.created >= lifetime || index < keys.length - 24) window.localStorage.removeItem(key);
      });
      const token = window.crypto.randomUUID();
      window.localStorage.setItem(storagePrefix + token, JSON.stringify({
        from: collectionPath(window.location.href), to: collectionPath(clean), group: group, created: Date.now()
      }));
      const url = new URL(clean);
      url.hash = marker.slice(1) + token;
      return url.href;
    } catch (_) { return clean; }
  }

  function prepareLink(event, navigation) {
    if (designMode || event.defaultPrevented || (event.type === 'click' && event.button !== 0) || (event.type === 'auxclick' && event.button !== 1)) return;
    const link = event.target.closest('.apella-subcollections__pill');
    if (!link || !navigation.contains(link)) return;
    const clean = cleanLinks.get(link) || link.href;
    const group = validGroup(snapshot(navigation), collectionPath(clean));
    if (!group) return;
    cleanLinks.set(link, clean);
    link.href = handoffURL(clean, group);
    if (event.type !== 'contextmenu') window.setTimeout(function () { link.href = clean; }, 0);
  }

  function urlForCollectionUpdate(url) {
    const path = collectionPath(url);
    return path === collectionPath(window.location.href) ? handoffURL(url, validGroup(currentGroup, path)) : url;
  }

  function enhance(navigation) {
    if (originals.has(navigation)) return;
    originals.set(navigation, { group: snapshot(navigation), hidden: navigation.hidden });
    if (currentGroup) render(navigation);
    ['click', 'auxclick', 'contextmenu'].forEach(function (type) {
      navigation.addEventListener(type, function (event) { prepareLink(event, navigation); });
    });
  }

  window.addEventListener('popstate', function () {
    currentGroup = designMode ? null : entryContext();
    document.querySelectorAll('[data-apella-subcollections]').forEach(function (navigation) {
      if (originals.has(navigation)) render(navigation);
    });
  });
  window.ApellaSubcollectionContext = { enhance: enhance, urlForCollectionUpdate: urlForCollectionUpdate };
})();
